export * from './helpdesk-search';

export * from './results/helpdesk-search-results';

import './helpdesk-search.scss';
